import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiErr } from "../lib/api";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reimpostata. Ora puoi accedere.");
      nav("/login");
    } catch (err) { setError(apiErr(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-lm-cream">
      <div className="w-full max-w-sm lm-anim">
        <img src="/logo-mascheroni.webp" alt="LM" className="h-9 mb-8" />
        <h2 className="font-display text-3xl text-lm-text mb-1">Nuova password</h2>
        <p className="text-sm text-lm-muted mb-8">Scegli una nuova password sicura.</p>
        {!token ? (
          <p className="text-sm text-[#991B1B]">Link non valido. Richiedi un nuovo reset.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="pw">Nuova password</Label>
              <Input id="pw" type="password" required minLength={6} data-testid="reset-password" value={password}
                onChange={(e) => setPassword(e.target.value)} className="mt-1.5 bg-white border-lm-sandsoft" />
            </div>
            {error && <p className="text-sm text-[#991B1B]">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="reset-submit" className="w-full bg-lm-brown hover:bg-lm-brownh text-lm-cream h-11">
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Reimposta password
            </Button>
          </form>
        )}
        <div className="text-center mt-6">
          <Link to="/login" className="text-sm text-lm-terra hover:underline inline-flex items-center gap-1"><ArrowLeft className="w-4 h-4" /> Torna all'accesso</Link>
        </div>
      </div>
    </div>
  );
}
